export const FiscalOnlineRegistrars = {
  en: {
    'Create Registrar': 'Create Registrar',
    'Cashier name': 'Cashier name',
    'Online payment key name': 'Online payment key name',
    Enabled: 'Enabled',
    Registrar: 'Registrar',
  },
  uk: {
    'Create Registrar': 'Створити Реєстратор',
    'Cashier name': 'Імʼя касира',
    'Online payment key name': 'Імʼя платіжного ключа',
    Enabled: 'Увімкнено',
    Registrar: 'Реєстратор',
  },
};

export const FiscalOnlineRegistrar = {
  en: {
    'Fiscal Online Registrars': 'Fiscal Online Registrars',
    'Service In / Out': 'Service In / Out',
    Confirm: 'Confirm',
    Print: 'Print',
    'With Confirmation': 'With Confirmation',
    TypedReport: '{{type}}-Report',
    Cashier: 'Cashier',
    Shift: 'Shift',
    "Doesn't exist": "Doesn't exist",
    'Open shift notice':
      'Closing the shift should be configured on the Сheckbox side',
    'Online Payment Key': 'Online Payment Key',
    'Select cashier': 'Select cashier',
    'Fiscal report details': 'Fiscal report details',
    'Are you sure you want to change the cashier?':
      'Are you sure you want to change the cashier?',
    'Are you sure you want to generate X Report?':
      'Are you sure you want to generate X Report?',
    'Are you sure you want to open a new shift?':
      'Are you sure you want to open a new shift?',
    'Are you sure you want to close the shift?':
      'Are you sure you want to close the shift?',
  },
  uk: {
    'Fiscal Online Registrars': 'Фіскальні Онлайн Реєстратори',
    'Service In / Out': 'Службові Внесення / Видача',
    Confirm: 'Підтвердити',
    Print: 'Друк',
    'With Confirmation': 'З Підтвердженням',
    TypedReport: '{{type}}-Звіт',
    Cashier: 'Касир',
    Shift: 'Зміна',
    "Doesn't exist": 'Не існує',
    'Open shift notice':
      'Закриття зміни повинно бути налаштовано на стороні Сheckbox.',
    'Online Payment Key': 'Платіжний ключ',
    'Select cashier': 'Оберіть касира',
    'Fiscal report details': 'Деталі фіскального звіту',
    'Are you sure you want to change the cashier?':
      'Ви впевнені, що хочете змінити касира?',
    'Are you sure you want to generate X Report?':
      'Ви впевнені, що хочете сформувати X-Звіт?',
    'Are you sure you want to open a new shift?':
      'Ви впевнені, що хочете відкрити нову зміну?',
    'Are you sure you want to close the shift?':
      'Ви впевнені, що хочете закрити зміну?',
  },
};

export const FiscalOnlineRegistrarForm = {
  en: {
    'New Fiscal Online Registrar': 'New Fiscal Online Registrar',
    'Create Fiscal Online Registrar': 'Create Fiscal Online Registrar',
    'Online Payment Key': 'Online Payment Key',
  },
  uk: {
    'New Fiscal Online Registrar': 'Новий Онлайн Реєстратор',
    'Create Fiscal Online Registrar': 'Створити Онлайн Реєстратор',
    'Online Payment Key': 'Платіжний ключ',
  },
};
